
export const RED_COLOR = 'red'
export const GREEN_COLOR = 'green'
export const ORANGE_COLOR = 'orange'
export const BLUE_COLOR = 'blue'
